<template>
  <v-dialog :value="dialogGastosCliente" persistent max-width="1100" scrollable>
    <v-card>
      <v-card-title class="font-weight-bold green lighten-4 primary--text"
        >Gastos Conta Cliente</v-card-title
      >
      <v-card-text>
        <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
        <v-data-table
          v-else
          :items="gastos"
          :headers="headers"
          no-data-text="Nenhum gasto encontrado"          
        >
          <template v-slot:top>
            <v-card flat color="grey lighten-3" min-width="200" class="mt-4">
              <v-card-title class="subtitle-2 font-weight-bold pt-3 text-center"
                >Total a pagar</v-card-title
              >
              <v-card-subtitle
                class="font-weight-bold red--text subtitle-1 pb-3"
                >{{ formatarMoeda(valorPagar) }}</v-card-subtitle
              >
            </v-card>
          </template>
          <template v-slot:[`item.valor`]="{ item }">
            {{ formatarMoeda(item.valor) }}
          </template>
          <template v-slot:[`item.juros`]="{ item }">
            {{ formatarMoeda(item.juros) }}
          </template>
          <template v-slot:[`item.baixas`]="{ item }">
            {{ formatarMoeda(item.baixas) }}
          </template>
          <template v-slot:[`item.saldo`]="{ item }">
            {{ formatarMoeda(item.saldo) }}
          </template>
          <template v-slot:[`item.produtos`]="{ item }">
            <compras-consumo :compra="item.id" />
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          @click="setDialogGastosCliente(false)"
          rounded
          small
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import { formatMoeda } from "@/global";
import ComprasConsumo from "../../../components/ComprasConsumo.vue";

export default {
  components: { ComprasConsumo },
  computed: mapState("home", ["dialogGastosCliente"]),
  watch: {
    dialogGastosCliente: async function (val) {
      if (val) {
        await this.getGastosContaCliente();
      }
    },
  },
  data: () => ({
    carregando: false,
    gastos: [],
    headers: [
      { text: "Estabelecimento", value: "desc_filial" },
      { text: "Emissão", value: "emissao" },
      { text: "Vcto", value: "vcto" },
      { text: "Docto", value: "docto" },
      { text: "Valor Orig.", value: "valor" },
      { text: "Juros", value: "juros" },
      { text: "Baixas", value: "baixas" },
      { text: "Valor a pagar", value: "saldo" },
      { text: "", value: "produtos" },
    ],
    valorPagar: 0,
  }),
  methods: {
    ...mapMutations("home", ["setDialogGastosCliente"]),
    async getGastosContaCliente() {
      this.carregando = true;
      this.gastos = [];
      await axios
        .get("/colaborador/financeiro?funcao=GASTOS-CLIENTE")
        .then((res) => {
          if (res.data.success) {
            this.gastos = res.data.data;
            this.calcularGastos();
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
      this.carregando = false;
    },
    calcularGastos() {
      this.valorPagar = 0;
      this.gastos.forEach((gasto) => (this.valorPagar += gasto.saldo));
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
  },
};
</script>

